import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { IPopupModel } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormComponent } from '../form/form.component';
import { NgClass } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ButtonLinkComponent } from '../buttons/button-link/button-link.component';

@Component({
  selector: 'mwe-popup',
  templateUrl: './popup.component.html',
  imports: [NgClass, TranslateDirective, FormComponent, ButtonLinkComponent, TranslatePipe],
})
export class PopupComponent {
  private activeModal = inject(NgbActiveModal);

  @ViewChild(FormComponent, { static: false }) formComponent: FormComponent;
  @Input() model: IPopupModel;
  @Input() size: 'small' | 'large' = 'large';
  @Output() onAdditionalButtonClick = new EventEmitter<string>();

  clickAdditionalButton(buttonId: string): void {
    this.onAdditionalButtonClick.emit(buttonId);
  }

  getAdditionalButtonId(buttonId: string, idx: string): string {
    return buttonId ? buttonId : 'mwe-additional-button-' + idx;
  }

  cancel(): void {
    this.activeModal.close('CANCEL');
  }

  submit(): void {
    if (this.model.formModel) {
      this.activeModal.close(this.formComponent.form.value);
    } else {
      this.activeModal.close(this.model.subscriptionId ? this.model.subscriptionId : 'OK');
    }
  }
}
